import React from "react";
import { ArrowLeft, Menu } from "lucide-react";
import { SidebarTrigger } from "@/shared/ui/kit/sidebar";

interface MobileTopBarProps {
    title: string;
    subtitle?: string;
    menuLabel: string;
    /** Troca o menu por "voltar" em telas de detalhe. */
    onBack?: () => void;
    backLabel?: string;
    /** Até duas ações de ícone à direita (busca, filtro, mais). */
    actions?: React.ReactNode;
}

export default function MobileTopBar({ title, subtitle, menuLabel, onBack, backLabel = "Voltar", actions }: MobileTopBarProps) {
    return (
        <header
            data-testid="mobile-top-bar"
            className="md:hidden shrink-0 h-14 box-content pt-[var(--safe-top)] flex items-center gap-2 px-2 bg-night_input dark:bg-night border-b border-white/10 text-white"
        >
            {onBack ? (
                <button
                    type="button"
                    onClick={onBack}
                    aria-label={backLabel}
                    className="h-11 w-11 shrink-0 inline-flex items-center justify-center rounded-lg text-yellow hover:bg-white/10"
                >
                    <ArrowLeft size={24} />
                </button>
            ) : (
                <SidebarTrigger aria-label={menuLabel} className="h-11 w-11 shrink-0 text-yellow hover:text-yellow">
                    <Menu size={24} />
                </SidebarTrigger>
            )}
            <div className="min-w-0 flex-1">
                <p className="text-[15px] font-semibold leading-tight truncate">{title}</p>
                {subtitle && <p className="text-xs text-white/60 leading-tight truncate">{subtitle}</p>}
            </div>
            {actions && <div className="flex shrink-0 items-center [&>*]:h-11 [&>*]:w-11">{actions}</div>}
        </header>
    );
}
